export default "__VITE_ASSET__B4KoMt5N__"